import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Map.css';
import handDrawMapImage from '../map.jpg';

const MapView = ({ apiKey, center, zoom, bounds, backgroundColor }) => {
  const userPositionRef = useRef(null);
  // State
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [userPosition, setUserPosition] = useState(null);
  const [isLocating, setIsLocating] = useState(false);
  const [showList, setShowList] = useState(false);

  // Refs
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const imageLayerRef = useRef(null);
  const markersRef = useRef([]);
  const userMarkerRef = useRef(null);
  const walkingRouteRef = useRef(null);
  const currentInfoWindowRef = useRef(null);
  const routePolylineRef = useRef(null);

  // 景点标记点数据
  const markerData = {
    attraction: [
      { lng: 121.050493, lat: 31.114263, name: '游客中心', audioUrl: '' },
      { lng: 121.053486, lat: 31.113777, name: '全华水彩艺术馆', audioUrl: '' },
      { lng: 121.053509, lat: 31.113438, name: '课植园', audioUrl: '' },
      { lng: 121.053553, lat: 31.112802, name: '和心园', audioUrl: '' },
      { lng: 121.056002, lat: 31.111608, name: '放生桥', audioUrl: '' },
      { lng: 121.055203, lat: 31.11095, name: '上海市鹤龙美术馆', audioUrl: '' },
      { lng: 121.055137, lat: 31.109868, name: '涵大隆酱园', audioUrl: '' },
      { lng: 121.055358, lat: 31.108915, name: '朱家角历史文化展厅', audioUrl: '' },
      { lng: 121.054655, lat: 31.111885, name: '朱家角古镇中心', audioUrl: '' },
      { lng: 121.054726, lat: 31.107974 , name: '童天和药号', audioUrl: '' },
      { lng: 121.053612, lat: 31.10706, name: '大清邮局', audioUrl: '' },
    ],
    route:[
      {
        name: '经典游览路线',
        walkPoints: [
          { lng: 121.0508, lat: 31.114344, name: '1' },
          { lng: 121.051526, lat: 31.114235, name: '2' },
          { lng: 121.05191, lat: 31.114197, name: '3' },
          { lng: 121.05262, lat: 31.114169, name: '4' },
          { lng: 121.052904, lat: 31.114199, name: '5' },
          { lng: 121.0535, lat:31.114101 , name: '6' },
          { lng: 121.053444, lat: 31.114031, name: '6' },
          { lng: 121.053485, lat: 31.113774, name: '7' },
          { lng: 121.053471, lat: 31.113348, name: '8' },
          { lng: 121.053531, lat: 31.113245, name: '9' },
          { lng: 121.05362, lat: 31.112904, name: '10' },
          { lng: 121.054286, lat: 31.112343, name: '11-中龙桥' },
          { lng: 121.054525, lat: 31.1121, name: '12-中龙桥前面的丁字路口' },
          { lng: 121.054617, lat:31.111869 , name: '13-钉子路口前面的拐点' },
          { lng: 121.054628, lat:31.111686 , name: '14-南桥小店' },
          { lng: 121.054755, lat:31.111703 ,name: '15-南桥小店过桥' },
          { lng: 121.054782, lat:31.111542 , name: '16-永安桥拐角' },
          { lng: 121.055137, lat:31.111606 , name: '17-永安桥前面的拐角' },
          { lng: 121.055261, lat:31.111674 , name: '18-阿婆小吃拐角' },
          { lng: 121.055287, lat:31.111752 , name: '19-阿婆小吃前面的拐角' },
          { lng: 121.055781, lat:31.111938 , name: '20-放生桥' },
          { lng: 121.055994, lat:31.111658 , name: '21-放生桥上' },
          { lng: 121.0562, lat:31.111323 , name: '22-放生桥过来的亭子下面' },
          { lng: 121.055558, lat:31.111069 , name: '23-江南第一茶楼' },
          { lng: 121.055224, lat:31.110923 , name: '24-上海鹤龙美术馆' },
          { lng: 121.055199, lat:31.110866 , name: '25-古镇游船码头' },
          { lng: 121.055223, lat:31.110809 , name: '26-功夫醉鹅拐角' },
          { lng: 121.055145, lat:31.110531 , name: '27-常兰食品店' },
          { lng: 121.055151, lat:31.110402 , name: '28-泗景园弄路口' },
          { lng: 121.055134, lat:31.110087, name: '29-古桥人家' },
          { lng: 121.055002, lat:31.109733 , name: '30-扎西文化体验馆拐角' },
          { lng: 121.054871, lat:31.109516 , name: '31-紫陶坊拐角' },
          { lng: 121.05463, lat:31.109315 , name: '32-古镇饭庄拐角' },
          { lng: 121.054482, lat:31.109043 , name: '33-馄顿王拐角' },
          { lng: 121.054365, lat:31.108965 , name: '34-360号' },
          { lng: 121.05432, lat:31.108702 , name: '35-十字路口' },
          { lng: 121.055719, lat:31.109051 , name: '36-拐进小道' },
          { lng: 121.054324, lat:31.108691 , name: '37-小道出来到十字路口' },
          { lng: 121.054329, lat:31.108533 , name: '38-人和玉前面的拐角' },
          { lng: 121.054408, lat:31.108193 , name: '39-戚家桥丁字路口' },
          { lng: 121.054491, lat:31.108047 , name: '40-那胜茶拐角' },
          { lng: 121.054693, lat:31.107862 , name: '41-东湖街丁字路口' },
          { lng: 121.05453, lat:31.107726 , name: '42-观音亭子' },
          { lng: 121.05428, lat:31.10734 , name: '43-桥水乡小酒馆' },
          { lng: 121.054264, lat:31.107275 , name: '44-花筑' },
          { lng: 121.054149, lat:31.107354 , name: '45-上桥' },
          { lng: 121.053999, lat:31.107414 , name: '46-下桥' },
          { lng: 121.053911, lat:31.107319 , name: '47-下桥拐点' },
          { lng: 121.053575, lat:31.107087 , name: '48-大清邮局' },
          { lng: 121.053911, lat: 31.107319, name: '49-下桥拐点' },
          { lng: 121.053999, lat: 31.107414, name: '50-下桥' },
          { lng:121.054139, lat:31.107603 , name: '51-喜园茶集' },
          { lng: 121.054205, lat:31.107765 , name: '52-小船咖啡' },
          { lng:121.054246, lat:31.10789, name: '53-小船咖啡拐角' },
          { lng: 121.054168, lat:31.108139 , name: '54-王氏民宅' },
          { lng: 121.054091, lat:31.108397 , name: '55-橘子树下民宿' },
        ],
        boatPoints: [
          { lng: 121.054102, lat:31.108523, name: '56-城隍庙码头' },
          { lng: 121.054158, lat:31.108662 , name: '57-城隍庙码头坐船水上观光点' },
          { lng: 121.054152, lat:31.108772 , name: '58-城隍庙码头坐船水上观光点2' },
          { lng: 121.054259, lat:31.109089 , name: '59-波拉波拉水上观光点3' },
          { lng: 121.054344, lat:31.109236 , name: '60-廊桥饭店水上观光点4' },
          { lng: 121.054545, lat:31.109487 , name: '61-望江楼水上观光点5' },
          { lng: 121.05484, lat:31.109828 , name: '62-水乡水上观光点6' },
          { lng: 121.055005, lat:31.110167 , name: '63-何家桥水上观光点7' },
          { lng: 121.055057, lat:31.110428 , name: '64-银杏树阿婆馆水上观光点8' },
          { lng: 121.054896, lat:31.110737 , name: '65-水上观光点9' },
          { lng: 121.054733, lat:31.111042, name: '66-水上观光点10' },
          { lng: 121.055125, lat: 31.111186, name: '67-水上观光点10-1' },
          { lng: 121.055932, lat:31.111536 , name: '67-水上观光点10-2' },
          { lng: 121.056391, lat:31.111657 , name: '67-水上观光点10-3' },
          { lng: 121.054768, lat:31.111309 , name: '67-阿婆茶楼入河口水上观光点11' },
          { lng: 121.054764, lat:31.11155 , name: '68-东井街水上观光点12' },
          { lng: 121.054706, lat:31.111903 , name: '69-文创集市水上观光点13' },
          { lng: 121.054621, lat:31.112115 , name: '70-得意轩水上观光点14' },
          { lng: 121.054559, lat:31.11221 , name: '71-得意轩水上观光点15' },
          { lng: 121.054065, lat:31.112625 , name: '72-兴穆水上观光点16' },
          { lng: 121.053761, lat:31.112885 , name: '73-韵歌养水上观光点17' },
          { lng: 121.053695, lat:31.113022 , name: '74-隐石佳水上观光点18' },
          { lng: 121.053634, lat:31.113542 , name: '75-课植园码头水上观光点19' },
        ]
      }
    ],
    parking: [
      { lng: 121.053925, lat: 31.11422, name: '课植园路F1停车场', audioUrl: '' },
      { lng: 121.050214, lat: 31.114153, name: '游客中心停车场', audioUrl: '' },
      { lng: 121.054726, lat: 31.107974, name: '证大停车场', audioUrl: '' },
      { lng: 121.058255, lat: 31.110651, name: '中南朱里雅集停车场', audioUrl: '' },
      { lng: 121.05802, lat: 31.108627, name: '新角里停车场', audioUrl: '' },
      { lng: 121.059165, lat: 31.10916, name: '影剧院广场停车场', audioUrl: '' },
    ],
    toilet: [
      { lng: 121.050488, lat: 31.11424, name: '游客中心公厕', audioUrl: '' },
      { lng: 121.05236, lat:31.113825, name: '课植园内公厕', audioUrl: '' },
      { lng: 121.053828, lat:31.11425 , name: '北桥头公厕', audioUrl: '' },
      { lng: 121.053429, lat:31.113072 , name: '曹家场公厕', audioUrl: '' },
      { lng: 121.05524, lat:31.111619 , name: '竹行头公厕', audioUrl: '' },
      { lng: 121.055963, lat:31.110274 , name: '泗泾弄公厕', audioUrl: '' },
      { lng: 121.057811, lat:31.110237 , name: '电灯厂公厕', audioUrl: '' },
      { lng: 121.055728, lat:31.10847 , name: '绿地广场公厕', audioUrl: '' },
      { lng: 121.055785, lat:31.107577 , name: '大新街道边公厕', audioUrl: '' },
      { lng: 121.054579, lat:31.107647 , name: '中观音桥公厕', audioUrl: '' },
      { lng: 121.053226, lat:31.106876 , name: '十七棣公厕', audioUrl: '' },
      { lng: 121.053944, lat:31.108663 , name: '城隍庙公厕', audioUrl: '' },
      { lng: 121.052564, lat:31.10817 , name: '镇中心边公厕', audioUrl: '' },
      { lng: 121.051484, lat:31.109348 , name: '漕平路大桥公厕', audioUrl: '' },
      { lng: 121.053072, lat:31.110399 , name: '漕港滩公厕', audioUrl: '' },
      { lng: 121.053705, lat:31.111211 , name: '木头行公厕', audioUrl: '' },
      { lng: 121.059705, lat: 31.109368, name: '镇电影院公厕', audioUrl: '' },
    ],
    pier: [
      { lng: 121.053479, lat:31.113549, name: '课植园码头', audioUrl: '' },
      { lng: 121.054111, lat:31.108521, name: '城隍庙码头', audioUrl: '' },
      { lng: 121.056235, lat:31.111487 , name: '放生桥码头', audioUrl: '' },
      { lng: 121.055185, lat:31.110859 , name: '北大街码头', audioUrl: '' },
      { lng: 121.049474, lat:31.101962 , name: '景区直通船', audioUrl: '' },
    ],
    service: [
      { lng: 121.055358, lat: 31.108915, name: '朱家角历史文化展厅', audioUrl: '' },
      { lng: 121.054726, lat: 31.107974, name: '童天和药号', audioUrl: '' },
      { lng: 121.053509, lat: 31.113438, name: '课植园', audioUrl: '' },
      { lng: 121.053553, lat: 31.112802, name: '和心园', audioUrl: '' },
      { lng: 121.053486, lat: 31.113777, name: '全华水彩艺术馆', audioUrl: '' },
      { lng: 121.0552,  lat:31.110944 , name: '上海市鹤龙美术馆', audioUrl: '' },
      { lng: 121.055185, lat: 31.110859, name: '北大街码头', audioUrl: '' },
      { lng: 121.053479, lat: 31.113549, name: '课植园码头', audioUrl: '' },
      { lng: 121.054111, lat: 31.108521, name: '城隍庙码头', audioUrl: '' },
      { lng: 121.056235, lat: 31.111487, name: '放生桥码头', audioUrl: '' },
      { lng: 121.049474, lat: 31.101962, name: '景区直通船', audioUrl: '' },
      { lng: 121.050493, lat: 31.114263, name: '游客中心', audioUrl: '' },
      { lng: 121.056648, lat: 31.109667 , name: '咨询服务站', audioUrl: '' },
    ],
    heritage:[//文保点位
      { lng: 121.053509, lat: 31.113438, name: '课植园', audioUrl: '' },
      { lng: 121.053553, lat: 31.112802, name: '和心园', audioUrl: '' },
      { lng: 121.05484, lat:31.111503 , name: '东井茶楼(阿婆茶楼)', audioUrl: '' },
      { lng: 121.055354, lat:31.108918 , name: '朱家角俱乐部茶楼', audioUrl: '' },
      { lng: 121.055137, lat: 31.109868, name: '涵大隆酱园', audioUrl: '' },
      { lng: 121.054726, lat: 31.107974, name: '童天和药号', audioUrl: '' },
      { lng: 121.053923, lat:31.108501 , name: '朱家角城隍庙', audioUrl: '' },
      { lng: 121.053612, lat: 31.10706, name: '大清邮局', audioUrl: '' },
      { lng: 121.05321, lat:31.114198 , name: '西井街139号水桥', audioUrl: '' },
      { lng: 121.053582, lat:31.114103 ,name:'涌泉桥', audioUrl: '' },
      { lng: 121.053518, lat:31.113968, name: '西井街101号水桥', audioUrl: '' },
      { lng: 121.054504, lat:31.112046 , name: '永禁勒碑', audioUrl: '' },
      { lng: 121.054591, lat:31.112123 , name: '西井街72号水桥', audioUrl: '' },
      { lng: 121.054622, lat: 31.112005, name: '西井街35号水桥', audioUrl: '' },
      { lng: 121.054371, lat:31.112256 , name: '张宅', audioUrl: '' },
      { lng: 121.054717, lat:31.112074 , name: '沈宅', audioUrl: '' },
      { lng: 121.054625, lat:31.112049 , name: '中龙桥', audioUrl: '' },
      { lng: 121.053967, lat:31.112485 , name: '舒宅', audioUrl: '' },
      { lng: 121.0547, lat:31.111691 , name: '永安桥', audioUrl: '' },
      { lng: 121.056002, lat: 31.111608, name: '放生桥', audioUrl: '' },
      { lng: 121.0564, lat:31.111425 , name: '禁网碑', audioUrl: '' },
      { lng: 121.055016, lat:31.11019 , name: '泰安桥', audioUrl: '' },
      { lng: 121.055023, lat:31.110118 , name: '北大街287号水桥(涵大隆酱园)', audioUrl: '' },
      { lng: 121.054469, lat:31.109655 , name: '龚宅', audioUrl: '' },
      { lng: 121.05438, lat:31.109264 , name: '平安桥', audioUrl: '' },
      { lng: 121.053972, lat:31.108521 , name: '漕河街93弄2号宅', audioUrl: '' },
      { lng: 121.0541, lat:31.108168 , name: '王宅', audioUrl: '' },
      { lng: 121.054113, lat:31.107368 , name: '永丰桥', audioUrl: '' },
      { lng: 121.053684, lat:31.107268 , name: '金宅', audioUrl: '' },
    ],
    food: [//角里味道
      { lng: 121.053768, lat:31.113039 , name: '隐石佳', audioUrl: '' },
      { lng: 121.053972, lat:31.11249 , name: '清代舒宅角里大院', audioUrl: '' },
      { lng: 121.055354, lat:31.111039 , name: '角里酒店', audioUrl: '' },
    ],
    hotel: [//角里栖舍
      { lng: 121.04867, lat:31.11496, name: '上海朱家角安麓酒店', audioUrl: '' },
      { lng: 121.05039, lat:31.12106 , name: '中信泰富朱家角锦江酒店', audioUrl: '' },
      { lng: 121.018796, lat:31.111324, name: '上海朱家角宽璟酒店', audioUrl: '' },
    ],
    shop: [//悦购角里
      { lng: 121.054, lat:31.111384 , name: '风和水手作', audioUrl: '' },
      { lng: 121.054697, lat:31.109304 , name: '森萃独立设计师品牌', audioUrl: '' },
      { lng: 121.056369, lat:31.111311 , name: '挽苏国风旗袍', audioUrl: '' },
    ]
  };

  // 菜单配置
  const menuItems = [
    { id: 'attraction', label: '景点', logo: 'a' },
    { id: 'route', label: '路线', logo: 'b' },
    { id: 'parking', label: '停车场', logo: 'c' },
    { id: 'toilet', label: '洗手间', logo: 'd' },
    { id: 'pier', label: '码头', logo: 'e' },
    { id: 'service', label: '咨询点', logo: 'f' },
    { id: 'heritage', label: '文保点位', logo: 'g' },
    { id: 'food', label: '角里味道', logo: 'h' },
    { id: 'hotel', label: '角里栖舍', logo: 'i' },
    { id: 'shop', label: '悦购角里', logo: 'j' }
  ];

  // 关闭当前信息窗体
  const closeCurrentInfoWindow = useCallback(() => {
    if (currentInfoWindowRef.current) {
      currentInfoWindowRef.current.close();
      currentInfoWindowRef.current = null;
    }
  }, []);

  // 清除步行路线
  const clearWalkingRoute = useCallback(() => {
    if (walkingRouteRef.current) {
      walkingRouteRef.current.clear();
      walkingRouteRef.current = null;
    }
  }, []);

  // 清除路线曲线
  const clearRoutePolyline = useCallback(() => {
    if (routePolylineRef.current) {
      mapInstanceRef.current.remove(routePolylineRef.current);
      routePolylineRef.current = null;
    }
  }, []);

  // 清除所有标记点
  const clearMarkers = useCallback(() => {
    closeCurrentInfoWindow();
    markersRef.current.forEach(marker => {
      marker.setMap(null);
    });
    markersRef.current = [];
  }, [closeCurrentInfoWindow]);

  // 同步图层顺序
  const syncLayerOrder = useCallback(() => {
    const map = mapInstanceRef.current;
    if (!map) return;

    if (imageLayerRef.current) {
      map.remove(imageLayerRef.current);
      map.add(imageLayerRef.current);
      imageLayerRef.current.setzIndex(50);
    }

    markersRef.current.forEach(m => {
      map.remove(m);
      map.add(m);
      m.setzIndex(200);
    });

    if (userMarkerRef.current) {
      map.remove(userMarkerRef.current);
      map.add(userMarkerRef.current);
      userMarkerRef.current.setzIndex(300);
    }
  }, []);

  // 设置地图背景色
  const setMapBackgroundColor = useCallback((bgColor) => {
    const color = bgColor || '#FBF5CA';
    const mapContainer = mapRef.current;
    if (mapContainer) {
      mapContainer.style.backgroundColor = color;
    }
    const mapWrapper = mapContainer?.querySelector('.amap-container');
    if (mapWrapper) {
      mapWrapper.style.backgroundColor = color;
    }
    const canvas = mapContainer?.querySelector('canvas');
    if (canvas) {
      canvas.style.backgroundColor = color;
    }
  }, []);

  // 初始化地图
  const initMap = useCallback(() => {
    if (!window.AMap) {
      setError('高德地图 API 未定义');
      setLoading(false);
      return;
    }

    try {
      mapInstanceRef.current = new window.AMap.Map(mapRef.current, {
        center: new window.AMap.LngLat(center[0], center[1]),
        zoom: zoom || 17,
        viewMode: '2D',
        dragEnable: true,
        zoomEnable: true,
        touchZoom: true,
        resizeEnable: true,
        showIndoorMap: false,
        features: [],
        zooms: [8, 18],
      });

      // 添加手绘地图图层   只需要注释掉这个if块就可以了，隐藏手绘地图，同时把上面的resizeEnable，showIndoorMap，features注释掉，就可以显示原来的地图了
      if (window.AMap && handDrawMapImage) {
        imageLayerRef.current = new window.AMap.ImageLayer({
          url: handDrawMapImage,
          bounds: new window.AMap.Bounds(
            new window.AMap.LngLat(bounds.sw[0], bounds.sw[1]),
            new window.AMap.LngLat(bounds.ne[0], bounds.ne[1])
          ),
          zooms: [8, 18],
          opacity: 1,
          zIndex: 50
        });
        mapInstanceRef.current.add(imageLayerRef.current);
      }

      setMapBackgroundColor(backgroundColor);

      mapInstanceRef.current.on('zoomend', syncLayerOrder);
      mapInstanceRef.current.on('mapmove', syncLayerOrder);

      mapInstanceRef.current.on('complete', () => {
        setMapBackgroundColor(backgroundColor);
        syncLayerOrder();
      });

      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  }, [center, zoom, bounds, backgroundColor, setMapBackgroundColor, syncLayerOrder]);

  // 加载高德地图脚本
  const loadMapScript = useCallback(() => {
    if (window.AMap) {
      initMap();
      return;
    }

    if (document.querySelector('script[src*="webapi.amap.com"]')) {
      const checkAMap = setInterval(() => {
        if (window.AMap) {
          clearInterval(checkAMap);
          initMap();
        }
      }, 100);
      return;
    }

    window._AMapSecurityConfig = {
      securityJsCode: "8bb0a3f58d3da5a0435852f788c79b25"
    };
    const script = document.createElement('script');
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${apiKey}&plugin=AMap.Geolocation,AMap.Walking,AMap.Driving`;
    script.async = true;
    script.onload = () => initMap();
    script.onerror = () => setError('地图加载失败');
    document.head.appendChild(script);
  }, [apiKey, initMap]);

  // 创建信息窗体内容
  const createInfoWindowContent = useCallback((item) => {
    const container = document.createElement('div');
    container.className = 'custom-info-window';
    container.innerHTML = `
      <div class="info-window-buttons">
        <div class="info-btn audio-btn" id="audio-btn-${item.name.replace(/\s/g, '')}">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
          </svg>
        </div>
        <div class="info-btn nav-btn" id="nav-btn-${item.name.replace(/\s/g, '')}">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"/>
          </svg>
        </div>
      </div>
    `;
    return container;
  }, []);

  // 创建简化版信息窗体（只显示名称）
  const createSimpleInfoWindowContent = useCallback((item) => {
    const container = document.createElement('div');
    container.className = 'custom-info-window simple-info-window';
    container.innerHTML = `<div class="simple-info-name">${item.name}</div>`;
    return container;
  }, []);

  // 显示路线选择弹窗
  const showRouteSelector = useCallback((routeInfo) => {
    const map = mapInstanceRef.current;
    if (!map || !window.AMap) return;

    // 移除已有的选择弹窗
    const existingModal = document.querySelector('.route-selector-modal');
    if (existingModal) existingModal.remove();

    // 创建弹窗
    const modal = document.createElement('div');
    modal.className = 'route-selector-modal';
    modal.innerHTML = `
      <div class="route-selector-content">
        <h3>选择游览路线</h3>
        <div class="route-options">
          <div class="route-option walk-route" data-type="walk">
            <div class="route-icon">
              <svg viewBox="0 0 24 24" width="40" height="40" fill="currentColor">
                <path d="M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 5.28c-1.23-.37-2.22-1.17-2.8-2.18l-1-1.6c-.41-.65-1.11-1-1.84-1-.78 0-1.59.5-1.78 1.44S7 23 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3c1 1.15 2.41 2.01 4 2.34V23H19V9.78c-.6-.15-1.21-.64-1.5-1.22z"/>
              </svg>
            </div>
            <div class="route-info">
              <span class="route-name">步行路线</span>
              <span class="route-desc">古镇步行游览（${routeInfo.walkPoints.length}个点位）</span>
            </div>
            <div class="route-color walk-color"></div>
          </div>
          <div class="route-option boat-route" data-type="boat">
            <div class="route-icon">
              <svg viewBox="0 0 24 24" width="40" height="40" fill="currentColor">
                <path d="M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"/>
              </svg>
            </div>
            <div class="route-info">
              <span class="route-name">水上路线</span>
              <span class="route-desc">游船水上观光（${routeInfo.boatPoints.length}个点位）</span>
            </div>
            <div class="route-color boat-color"></div>
          </div>
        </div>
        <button class="route-close-btn">关闭</button>
      </div>
    `;

    mapRef.current.appendChild(modal);

    // 关闭按钮
    modal.querySelector('.route-close-btn').onclick = () => modal.remove();

    // 路线选项点击
    modal.querySelectorAll('.route-option').forEach(option => {
      option.onclick = () => {
        const type = option.dataset.type;
        modal.remove();
        displayRoute(routeInfo, type);
      };
    });
  }, []);

  // 显示指定路线
  const displayRoute = useCallback((routeInfo, type) => {
    const map = mapInstanceRef.current;
    if (!map || !window.AMap) return;

    clearRoutePolyline();
    clearMarkers();

    const points = type === 'walk' ? routeInfo.walkPoints : routeInfo.boatPoints;
    const color = type === 'walk' ? '#FF6600' : '#1890ff'; // 步行橙色，水上蓝色

    // 使用 Polyline 连接所有点
    const path = points.map(p => new window.AMap.LngLat(p.lng, p.lat));

    routePolylineRef.current = new window.AMap.Polyline({
      path: path,
      strokeWeight: 5,
      strokeColor: color,
      strokeOpacity: 0.9,
      strokeStyle: 'solid',
      zIndex: 150,
      isOutline: true,
      outlineColor: '#ffffff',
      lineJoin: 'round'
    });
    map.add(routePolylineRef.current);
    syncLayerOrder();

    // 路线上的景点标记
    const startIcon = new window.AMap.Icon({
      size: new window.AMap.Size(32, 42),
      image: 'https://webapi.amap.com/theme/v1.3/markers/navigationstart.png',
      imageSize: new window.AMap.Size(32, 42)
    });

    const endIcon = new window.AMap.Icon({
      size: new window.AMap.Size(32, 42),
      image: 'https://webapi.amap.com/theme/v1.3/markers/navigation.png',
      imageSize: new window.AMap.Size(32, 42)
    });

    const spotIcon = new window.AMap.Icon({
      size: new window.AMap.Size(24, 24),
      image: 'https://webapi.amap.com/theme/v1.3/markers/marker.png',
      imageSize: new window.AMap.Size(24, 24)
    });

    points.forEach((point, index) => {
      let icon;
      if (index === 0) {
        icon = startIcon;
      } else if (index === points.length - 1) {
        icon = endIcon;
      } else {
        icon = spotIcon;
      }

      const marker = new window.AMap.Marker({
        position: [point.lng, point.lat],
        icon: icon,
        title: point.name,
        offset: new window.AMap.Pixel(-16, -42),
        zIndex: 200
      });

      marker.on('click', () => {
        closeCurrentInfoWindow();

        const infoWindow = new window.AMap.InfoWindow({
          isCustom: true,
          content: createInfoWindowContent(point),
          offset: new window.AMap.Pixel(0, -45),
          closeWhenClickMap: true
        });

        infoWindow.open(map, marker.getPosition());
        currentInfoWindowRef.current = infoWindow;

        setTimeout(() => {
          const audioBtn = document.getElementById(`audio-btn-${point.name.replace(/\s/g, '')}`);
          const navBtn = document.getElementById(`nav-btn-${point.name.replace(/\s/g, '')}`);

          if (audioBtn) {
            audioBtn.onclick = (e) => {
              e.stopPropagation();
              alert(`播放 ${point.name} 的语音讲解`);
            };
          }

          if (navBtn) {
            navBtn.onclick = (e) => {
              e.stopPropagation();
              startNavigation(point.lng, point.lat);
            };
          }
        }, 100);
      });

      marker.setMap(map);
      markersRef.current.push(marker);
    });

    syncLayerOrder();
  }, [clearRoutePolyline, clearMarkers, createInfoWindowContent, syncLayerOrder, closeCurrentInfoWindow]);

  // 显示标记点
  const showMarkers = useCallback((menuId) => {
    const map = mapInstanceRef.current;
    if (!map || !window.AMap) return;

    closeCurrentInfoWindow();
    clearWalkingRoute();
    clearRoutePolyline();
    clearMarkers();

    const data = markerData[menuId];
    if (!data) return;

    // 路线类型 - 显示路线选择弹窗
    if (menuId === 'route' && data[0]?.walkPoints) {
      showRouteSelector(data[0]);
      return;
    }

    // 判断是否使用带图标的弹窗（景点使用完整功能，其他使用简化版）
    const useFullInfoWindow = menuId === 'attraction';

    // 使用本地红色标注图标
    const icon = new window.AMap.Icon({
      size: new window.AMap.Size(32, 42),
      image: '/marker-red.svg',
      imageSize: new window.AMap.Size(32, 42)
    });

    data.forEach(item => {
       const marker = new window.AMap.Marker({
        position: [item.lng, item.lat],
        title: item.name,
        anchor: 'bottom-center',
        zIndex: 200
      });
      marker.on('click', () => {
        closeCurrentInfoWindow();

        const infoWindow = new window.AMap.InfoWindow({
          isCustom: true,
          content: useFullInfoWindow ? createInfoWindowContent(item) : createSimpleInfoWindowContent(item),
          offset: new window.AMap.Pixel(0, -45),
          closeWhenClickMap: true
        });

        infoWindow.open(map, marker.getPosition());
        currentInfoWindowRef.current = infoWindow;

        // 景点弹窗绑定语音和导航按钮事件
        if (useFullInfoWindow) {
          setTimeout(() => {
            const audioBtn = document.getElementById(`audio-btn-${item.name.replace(/\s/g, '')}`);
            const navBtn = document.getElementById(`nav-btn-${item.name.replace(/\s/g, '')}`);

            if (audioBtn) {
              audioBtn.onclick = (e) => {
                e.stopPropagation();
                alert(`播放 ${item.name} 的语音讲解`);
              };
            }

            if (navBtn) {
              navBtn.onclick = (e) => {
                e.stopPropagation();
                startNavigation(item.lng, item.lat);
              };
            }
          }, 100);
        }
      });

      marker.setMap(map);
      markersRef.current.push(marker);
    });

    syncLayerOrder();
  }, [closeCurrentInfoWindow, clearWalkingRoute, clearMarkers, createInfoWindowContent, createSimpleInfoWindowContent, syncLayerOrder]);

  // 显示用户位置标记
  const showUserMarker = useCallback((position) => {
    const map = mapInstanceRef.current;
    if (userMarkerRef.current) {
      userMarkerRef.current.setMap(null);
    }

    // 创建自定义呼吸动画元素
    const createBreatheMarker = () => {
      const container = document.createElement('div');
      container.className = 'user-location-marker';

      const pulse1 = document.createElement('div');
      pulse1.className = 'user-location-pulse';

      const pulse2 = document.createElement('div');
      pulse2.className = 'user-location-pulse';

      const pulse3 = document.createElement('div');
      pulse3.className = 'user-location-pulse';

      const dot = document.createElement('div');
      dot.className = 'user-location-dot';

      container.appendChild(pulse1);
      container.appendChild(pulse2);
      container.appendChild(pulse3);
      container.appendChild(dot);

      return container;
    };

    const userIcon = new window.AMap.Marker({
      content: createBreatheMarker(),
      position: position,
      offset: new window.AMap.Pixel(-30, -30),
      zIndex: 300
    });

    userIcon.setMap(map);
    userMarkerRef.current = userIcon;
    syncLayerOrder();
  }, [syncLayerOrder]);

  // 浏览器原生定位
  const getBrowserLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setIsLocating(false);
      alert('您的浏览器不支持定位功能');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setIsLocating(false);
        const lngLat = new window.AMap.LngLat(
          position.coords.longitude,
          position.coords.latitude
        );
        setUserPosition(lngLat);
        userPositionRef.current = lngLat;
        showUserMarker(lngLat);
      },
      (error) => {
        setIsLocating(false);
        let msg = '定位失败';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            msg = '定位权限被拒绝，请在浏览器设置中允许定位';
            break;
          case error.POSITION_UNAVAILABLE:
            msg = '无法获取当前位置，请确保 GPS 定位开启';
            break;
          case error.TIMEOUT:
            msg = '定位超时，请检查网络';
            break;
          default:
            msg = '定位失败，请检查网络或 GPS 设置';
        }
        console.error('浏览器定位失败:', error);
        alert(msg);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 60000
      }
    );
  }, [showUserMarker]);

  // 获取用户当前位置
  const getUserLocation = useCallback(async () => {
    const map = mapInstanceRef.current;

    if (userMarkerRef.current) {
      userMarkerRef.current.setMap(null);
      userMarkerRef.current = null;
    }
    setUserPosition(null);
    setIsLocating(true);

    if (!map) {
      setIsLocating(false);
      alert('地图未初始化完成');
      return;
    }

    try {
      await new Promise((resolve, reject) => {
        if (window.AMap.Geolocation) {
          resolve();
          return;
        }
        map.plugin('AMap.Geolocation', () => {
          if (window.AMap.Geolocation) {
            resolve();
          } else {
            reject(new Error('Geolocation 插件加载失败'));
          }
        });
      });

      const geolocation = new window.AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 15000,
        showMarker: false,
        showCircle: false,
        panToLocation: false,
        convert: true
      });

      geolocation.getCurrentPosition((status, result) => {
        console.log(status, result);
        setIsLocating(false);

        if (status === 'complete' && result) {
          const position = new window.AMap.LngLat(
            result.position.lng,
            result.position.lat
          );
          setUserPosition(position);
          userPositionRef.current = position;
          showUserMarker(position);
        } else if (status === 'error') {
          console.log('高德定位失败，尝试浏览器原生定位:', result);
          getBrowserLocation();
        }
      });
    } catch (err) {
      setIsLocating(false);
      console.error('定位插件加载失败:', err);
      getBrowserLocation();
    }
  }, [showUserMarker, getBrowserLocation]);

  // 开始导航
  const startNavigation = useCallback(async (targetLng, targetLat) => {
    const map = mapInstanceRef.current;

    console.log('导航状态检查:', { userPosition, targetLng, targetLat });

    const position = userPositionRef.current;

    if (!position) {
      alert('请先获取您的位置信息');
      return;
    }

    clearWalkingRoute();

    try {
      await new Promise((resolve, reject) => {
        if (window.AMap.Walking) {
          resolve();
          return;
        }
        map.plugin('AMap.Walking', () => {
          if (window.AMap.Walking) {
            resolve();
          } else {
            reject(new Error('Walking 插件加载失败'));
          }
        });
      });

      walkingRouteRef.current = new window.AMap.Walking({
        map: map,
        panel: null,
        hideMarkers: true,
        isOutline: true,
        outlineColor: '#ffffff',
        extensible: false
      });

      console.log('开始规划路线，从', userPosition, '到', targetLng, targetLat);

      let startLng, startLat;
      if (position instanceof window.AMap.LngLat) {
        startLng = position.getLng();
        startLat = position.getLat();
      } else if (Array.isArray(position)) {
        [startLng, startLat] = position;
      } else {
        startLng = position.lng;
        startLat = position.lat;
      }


      walkingRouteRef.current.search(
        [startLng, startLat],
        [targetLng, targetLat],
        (status, result) => {
          // console.log("导航结果", status, result);
          if (status === 'complete' && result.routes && result.routes.length > 0) {

            const route = result.routes[0];
            const distance = route.distance;

            // console.log("规划成功 距离:", distance);

            map.setFitView();

          } else if (status === 'no_data') {

            alert("该区域没有可规划的步行路线");

          } else {

            alert("导航失败");

          }
        }
      );
    } catch (err) {
      console.error('导航插件加载失败:', err);
      alert('导航插件加载失败，请刷新页面重试');
    }
  }, [userPosition, clearWalkingRoute]);

  // 菜单点击处理
  const handleMenuClick = useCallback((menuId) => {
    const newSelected = selectedMenu === menuId ? null : menuId;
    setSelectedMenu(newSelected);
    // 路线菜单不显示列表
    setShowList(newSelected && menuId !== 'route' ? true : false);

    if (newSelected) {
      showMarkers(newSelected);
    } else {
      clearMarkers();
      clearWalkingRoute();
      clearRoutePolyline();
    }
  }, [selectedMenu, showMarkers, clearMarkers, clearWalkingRoute, clearRoutePolyline]);

  // 点击列表项
  const handleListItemClick = useCallback((item) => {
    const map = mapInstanceRef.current;
    if (!map || !window.AMap) return;

    closeCurrentInfoWindow();

    // 地图移动到该位置
    map.setCenter([item.lng, item.lat]);

    // 显示信息窗体
    const infoWindow = new window.AMap.InfoWindow({
      isCustom: true,
      content: createInfoWindowContent(item),
      offset: new window.AMap.Pixel(0, -45),
      closeWhenClickMap: true
    });

    infoWindow.open(map, new window.AMap.LngLat(item.lng, item.lat));
    currentInfoWindowRef.current = infoWindow;

    // 绑定按钮事件
    setTimeout(() => {
      const audioBtn = document.getElementById(`audio-btn-${item.name.replace(/\s/g, '')}`);
      const navBtn = document.getElementById(`nav-btn-${item.name.replace(/\s/g, '')}`);

      if (audioBtn) {
        audioBtn.onclick = (e) => {
          e.stopPropagation();
          alert(`播放 ${item.name} 的语音讲解`);
        };
      }

      if (navBtn) {
        navBtn.onclick = (e) => {
          e.stopPropagation();
          startNavigation(item.lng, item.lat);
        };
      }
    }, 100);
  }, [createInfoWindowContent, closeCurrentInfoWindow, startNavigation]);

  // 获取当前选中菜单的数据
  const getCurrentListData = useCallback(() => {
    if (!selectedMenu) return [];
    const data = markerData[selectedMenu];
    if (Array.isArray(data) && data[0]?.walkPoints) {
      return data[0].walkPoints;
    }
    return data || [];
  }, [selectedMenu]);

  // 生命周期：组件挂载
  useEffect(() => {
    loadMapScript();

    return () => {
      clearMarkers();
      clearWalkingRoute();
      clearRoutePolyline();
      if (mapInstanceRef.current) {
        mapInstanceRef.current.off('zoomend', syncLayerOrder);
        mapInstanceRef.current.off('mapmove', syncLayerOrder);
        mapInstanceRef.current.destroy();
      }
    };
  }, [loadMapScript, clearMarkers, clearWalkingRoute, clearRoutePolyline, syncLayerOrder]);

  return (
    <div className="map-container">
      {loading && (
        <div className="map-loading">
          <div className="loading-spinner"></div>
          <p>正在加载地图...</p>
        </div>
      )}
      {error && (
        <div className="map-error">
          <p>{error}</p>
        </div>
      )}

      <div className="map-background-overlay" />

      <div ref={mapRef} className="map-view" />

      {/* 定位按钮 */}
      <div
        className="location-btn"
        onClick={getUserLocation}
        title="定位我的位置"
      >
        {isLocating ? (
          <div className="location-spinner"></div>
        ) : (
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
          </svg>
        )}
      </div>

      <div className="bottom-menu-bar">
        {/* 景点列表 */}
        {showList && selectedMenu && (
          <div className="poi-list-panel">
            <div className="poi-list-header">
              <span className="poi-list-title">{menuItems.find(m => m.id === selectedMenu)?.label || '景点列表'}</span>
              <span className="poi-list-count">{getCurrentListData().length}个</span>
              <span className="poi-list-close" onClick={() => handleMenuClick(selectedMenu)}>×</span>
            </div>
            <div className="poi-list-content">
              {getCurrentListData().map((item, index) => (
                <div
                  key={index}
                  className="poi-list-item"
                  onClick={() => handleListItemClick(item)}
                >
                  <span className="poi-item-name">{item.name}</span>
                  <span className="poi-item-arrow">›</span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="menu-scroll-container">
          {menuItems.map(item => (
            <div
              key={item.id}
              className={`menu-item ${selectedMenu === item.id ? 'selected' : ''}`}
              onClick={() => handleMenuClick(item.id)}
            >
              <img
                className="menu-logo"
                src={require(`../images/${item.logo}${selectedMenu === item.id ? '_sel' : ''}.png`)}
                alt={item.label}
              />
              <span className="menu-label">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MapView;
